import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-external-url-loader',
  template: '<div class="wrapper"><p class="bold">Redirecting...</p></div>',
  standalone: false,
})
export class ExternalUrlLoaderComponent implements OnInit {
  private readonly ALLOWED_URLS = environment.externalRedirect.urls;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    try {
      const externalUrl = this.route.snapshot.data['externalUrl'];

      // Find exact match in allowed URLs
      const matchedUrl = this.ALLOWED_URLS.find((url) => url === externalUrl);

      if (matchedUrl) {
        location.replace(matchedUrl);
      } else {
        throw new Error('Unauthorized redirect attempt');
      }
    } catch (error) {
      console.error('Security violation:', error);
      this.router.navigate(['/']);
    }
  }
}
